const o = "_icon_1oy32_1", s = "_disabled_1oy32_5", d = {
  icon: o,
  disabled: s
};
export {
  d as default,
  s as disabled,
  o as icon
};
//# sourceMappingURL=index.es671.js.map
